import { useLayoutEffect, useMemo, useState } from 'react';
import { saveTypes, wardTypes } from '../../../ProbabilityHome.constant';
import { Button, Col, Container, FloatingLabel, Form, Offcanvas, Row } from 'react-bootstrap';
import Unit from '../../../../types/Unit/Unit';

import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import AttackBonuses, { AttackBonusDetails, defaultAttackBonusDetails } from '../AttackBonuses/AttackBonuses';
import useAttackEvaluation from '../../../../hooks/useAttackEvaluation/useAttackEvaluation';

import style from './DamageDisplay.module.css';
import AverageDamage from '../AverageDamage/AverageDamage';

interface DamageDisplayProps {
  unit: Unit;
}

function DamageDisplay({ unit }: DamageDisplayProps) {
  const [attackBonusDetails, setAttackBonusDetails] = useState<AttackBonusDetails>({ ...defaultAttackBonusDetails });

  const [saveType, setSaveType] = useState(saveTypes[2]);
  const [wardType, setWardType] = useState(wardTypes[0]);
  const [isEthereal, setIsEthereal] = useState(false);
  const [didCharge, setDidCharge] = useState(false);

  const [showOptions, setShowOptions] = useState(false);

  const [rangeType, setRangeType] = useState('MELEE');

  useLayoutEffect(() => {
    setAttackBonusDetails({ ...defaultAttackBonusDetails });
  }, [unit]);
  
  const saveMenuItems = useMemo(() => saveTypes.map((t, i) => (
    <option key={`save${i}`} value={t}>{t}</option>
  )), []);
      
  const wardMenuItems = useMemo(() => wardTypes.map((t, i) => (
    <option key={`ward${i}`} value={t}>{t}</option>
  )), []);

  const { damageDistribution, averageDamage, attackProfiles } = useAttackEvaluation({
    unit,
    ...attackBonusDetails,
    save: saveType,
    ward: wardType,
    isEthereal,
    didCharge,
    rangeType
  });
  
  return (
    <div>
      <div>
        <Container fluid className="p-0">
          <Row className="mt-1 mb-3">
            <Col>
              <Form.Check
                inline
                id="meleeCheck"
                label="Melee"
                name="group1"
                type="radio"
                defaultChecked
                className={style.outputText}
                onChange={() => setRangeType('MELEE')}
              />
            </Col>

            <Col>
              <Form.Check
                inline
                id="rangeCheck"
                name="group1"
                label="Ranged"
                type="radio"
                className={style.outputText}
                onChange={() => setRangeType('RANGED')}
              />
            </Col>
          </Row>
          

          {attackProfiles.map((profile, i) => {
            const { name, numAttacks, hit, wound, rend, damage } = profile;
            return (
              <Row key={`splitRow${i}`} className="mb-2">
                <span style={{ fontWeight: '500' }}>{name}:</span>
                <br />
                <span>{numAttacks} attacks, {hit}+/{wound}+/{rend}/{damage}</span>
              </Row>
            );
          })}

          <AverageDamage damageDistribution={damageDistribution} averageDamage={averageDamage} />
        </Container>
      </div>

      <Form.Group as={Row} className="mb-3">
        <Col>
          <FloatingLabel label="Save">
            <Form.Select defaultValue={saveType} onChange={(event) => setSaveType(event.target.value)}>
              {saveMenuItems}
            </Form.Select>
          </FloatingLabel>
        </Col>
        
        <Col>
          <FloatingLabel label="Ward">
            <Form.Select onChange={(event) => setWardType(event.target.value)}>
              {wardMenuItems}
            </Form.Select>
          </FloatingLabel>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Col>
          <Form.Check id="etherealCheck" label="Ethereal" className="mb-3" onChange={(event) => setIsEthereal(event.target.checked)} />
        </Col>
        
        <Col>
          <Form.Check id="didChargeCheck" label="Did charge" onChange={(event) => setDidCharge(event.target.checked)} />
        </Col>
      </Form.Group>
      
      <Form.Group as={Row}>
        <Button onClick={() => setShowOptions(!showOptions)}>Options</Button>
      </Form.Group>

      <Offcanvas 
        style={{ height: 'calc(100vh - 100px)', padding: '5%', overflow: 'auto' }} 
        show={showOptions} 
        onHide={() => setShowOptions(false)} 
        placement="bottom"
      >
        <Offcanvas.Body>
          <AttackBonuses attackBonusDetails={attackBonusDetails} onAttackBonusChange={setAttackBonusDetails}/>
          <Button onClick={() => setShowOptions(false)}>Done</Button>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default DamageDisplay;